/* eslint-disable func-names */

import { debounce } from '../helpers/helpers';

/**
 * Defer video loading until it is determined that the screen size is larger than 1200px
 */
const videoLoader = () => {
  // eslint-disable-next-line no-undef
  const $ = jQuery;
  const isDesktop = window.matchMedia('(min-width: 1200px)').matches;
  const $source = $('.js-video-deferred source');
  let videosLoaded = false;

  /**
   * Update the src attributes of source elements and load the video
   */
  const loadVideos = () => {
    if (isDesktop) {
      $source.each(function () {
        $(this).attr('src', $(this).data('src'));
      });

      $source.each(function () {
        if ($(this).parent()[0].readyState !== 4) {
          $(this).parent()[0].load();
        }
      });

      videosLoaded = true;
    }
  };

  if ($source.length && !videosLoaded) {
    loadVideos();
    $('window').on('resize', debounce(100, loadVideos));
  }
};

export default videoLoader;
